export const PRESET_EMOJIS = ['👍', '❤️', '🔥', '🎉', '💯'] as const;

export const QUICK_EMOJI = '👍';

export type PresetEmoji = (typeof PRESET_EMOJIS)[number];
